const routes = {
  searchResults: '/results',
  unavailable: '/unavailable',
  bookAura: '/bookaura',
}

export default routes
